import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserAddress } from '../interfaces/user-address.interface';

const apiUrl = environment.apiUrl + 'user/user_address';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  addresses: BehaviorSubject<any> = new BehaviorSubject(null);
  editAddressState: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient) {}

  setEditAddressState(address: UserAddress) {
    this.editAddressState.next(address);
  }

  getEditAddressState() {
    return this.editAddressState.asObservable();
  }

  private fetchAddresses() {
    const body = {
      item_per_page: 100,
      current_page: 1,
    };
    return this.http
      .post<UserAddress>(apiUrl + '/search', body)
      .pipe(
        map((res: any) => {
          const addresses = res.data.user_addresses;
          return addresses;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getAddresses() {
    if (!this.addresses.value) {
      this.fetchAddresses().subscribe((data) => {
        this.addresses.next(data);
        return data;
      });
    }
    return this.addresses.asObservable();
  }

  getAddress(addressId: number | string) {
    return this.http
      .get<UserAddress>(apiUrl + '/' + addressId)
      .pipe(
        map((res: any) => {
          const address: UserAddress = res['data'];
          return address;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  addAddress(newAddress: UserAddress) {
    return this.http
      .post(apiUrl, newAddress)
      .pipe(
        map((res: any) => {
          const address: UserAddress = res['data'];
          const addresses: UserAddress[] = [...this.addresses.value, address];
          this.addresses.next(addresses);
          this.handleSuccess('Successfully added new address');
          return address;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  editAddress(addressId: number | string, updatedAddress: UserAddress) {
    return this.http
      .put(apiUrl + '/' + addressId, updatedAddress)
      .pipe(
        map((res: any) => {
          const address: UserAddress = res['data'];
          if (this.addresses.value) {
            this.handleEditAddress(address);
          }
          return address;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  deleteAddress(addressId: string) {
    return this.http
      .delete(apiUrl + '/' + addressId)
      .pipe(
        map((res: any) => {
          const addresses: UserAddress[] = this.addresses.value.filter(
            (address: any) => address.id !== addressId
          );
          this.addresses.next(addresses);
          this.handleSuccess('address deleted successfully');
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  private handleEditAddress(updatedAddress: UserAddress) {
    const addresses: UserAddress[] = [...this.addresses.value];
    const addressIndex: number = addresses.findIndex(
      (address) => address.id === updatedAddress.id
    );
    addresses[addressIndex] = updatedAddress;
    this.addresses.next(addresses);
    this.handleSuccess('address updated successfully');
    return addresses;
  }

  private handleSuccess(message: string) {}
}
